<template>
    <div class="wrap">
        <div>
            <Banner></Banner>
        </div>
        <div class="content">
            <div class="hint">
                    <label>{{hint}}</label>
            </div>
            <div class="title">
                    <label>第{{times}}次观念调查</label>
            </div>
            <div class="question-wrap" v-for="(question,index) in questions" v-bind:key="index">
                    <div class="question">
                            <label>{{index+1}}、{{question.question}}({{question.type==1?"单选题":"多选题"}})</label>
                    </div>
                    <div class="resolves">
                        <div class="resolve" v-for="(resolve,index) in question.resolves" v-bind:key="index" @click="resolveSelect(question,resolve)">
                            <span class="radio" :class="resolve.check==0?'radio-uncheck':'radio-check'"></span>
                            <label>{{resolve.resolve}}</label>
                        </div>
                        <div class="reason" v-if="reasonShow(question)">
                            <input type="text" placeholder="请输入其他理由" :id="'reason'+(index+1)" >
                        </div>
                    </div>
            </div>
            <div class="submit" @click="toSubmit">
                <label>{{submit}}</label>
            </div>
        </div>
    </div>
</template>

<script>
    import {ksdDocSurvey} from "@/assets/js/api";
    import Banner from "@/components/ksd/fragment/Banner";
    export default {
        name: "survey1",
        components:{
            Banner
        },
        data(){
            return{
                times:"一",
                hint:"为更好的了解医务工作人员在临床实践中对高血压患者的规范化管理现状，诚邀您参与此次调查！",
                submit:"提交",
                phase:0,
                docId:this.$store.state.ksd_docId,
                questions:[],
                questions1: [
                    {
                        question:"以下关于高血压目标值的描述，您认可的是：",
                        type:"2",
                        resolves:[{
                            resolve:"A.<65岁者，血压<130/80 mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"B. ≥65岁者，血压<140/90 mmHg，老年患者根据自身虚弱情况设定个体化的血压目标",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 一般成人高血压患者降压目标值为<140/90mmHg",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 高危、合并CVD高血压的患者，或合并高血压的卒中或TIA患者，血压应控制在＜130/80mmHg;",
                            check:0,
                            isAnswer:1
                        },
                        ]},
                    {
                        question:"对于既往经单药（ACEI、ARB、CCB、利尿剂）治疗后血压不达标的患者，您最优先考虑的调整治疗方案是？",
                        type:"1",
                        resolves:[{
                            resolve:"A. 同品类降压药增加剂量（举例：ACEI类药物单药增加剂量）",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 不同品类降压药转换（举例：ARB类药物换ACEI类药物）",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 换药，直接更换成SPC（举例：ACEI+CCB类SPC）",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D. 自由联合其他药物（举例：ACEI类、CCB类）",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"E. 其他情况（请说明）",
                            check:0,
                            isAnswer:0
                        }

                        ]},
                    {
                        question:"关于高血压的治疗，对于哪些患者您考虑起始治疗使用单片复方制剂（SPC）？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 绝大多数高血压患者都可以选择SPC起始治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 有大于等于160/100mmHg（或高于目标值20mmHg）的患者，应该考虑SPC起始治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C. 心血管风险为高危/很高危的患者，应该考虑SPC起始治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 不认同起始SPC的理念",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 其他情况（请说明）",
                            check:0,
                            isAnswer:1
                        }
                        ]
                    },
                    {
                        question:"对于A+C SPC，您认为在哪些方面较A+D SPC 有所优势？",
                        type:"2",
                        resolves:[{
                            resolve:"A. A+C SPC较A+D SPC：适用人群广",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. A+C SPC较A+D SPC：血压达标率高",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. A+C SPC较A+D SPC：循证证据充分",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. A+C SPC较A+D SPC：获更多指南的推荐",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"对于A+C SPC的选择，您优先考虑的三个因素是什么？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 强效降压（降压幅度大）",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 平稳降压（波动小）",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 长效降压（半衰期长）",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 快速起效",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 早期达标",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"F. 有心血管保护作用",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"G.服药方便/患者依从性高",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"对比其他A+C的SPC（缬沙坦/氨氯地平片等），您认为10mg精氨酸培哚普利+5mg氨氯地平SPC在以下哪些方面更有优势？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 血压达标率高",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 降压幅度高",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 半衰期长",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 平稳降压，有效控制24h血压",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 心血管保护（降低全因死亡率和心血管事件）",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"您在使用10mg精氨酸培哚普利+5mg氨氯地平SPC过程中最大的顾虑是？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 担心发生低血压风险",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 担心出现咳嗽问题",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 担心有水肿问题",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 单片复方制剂，不能掰片使用",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E.其他情况（请说明）",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"以下哪些是10mg精氨酸培哚普利+5mg氨氯地平SPC 的产品信息？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 更长半衰期，确保24小时长效平稳降压",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 治疗12周，血压达标率可达93.5%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. ASCOT研究证实更优心脑肾保护",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 高血压患者的基础疗法",
                            check:0,
                            isAnswer:1
                        }]
                    },
                ],
                questions2: [
                    {
                        question:"以下关于高血压目标值的描述，您认可的是：",
                        type:"2",
                        resolves:[{
                            resolve:"A.<65岁者，血压<130/80 mmHg",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"B. ≥65岁者，血压<140/90 mmHg，老年患者根据自身虚弱情况设定个体化的血压目标",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 一般成人高血压患者降压目标值为<140/90mmHg",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 高危、合并CVD高血压的患者，或合并高血压的卒中或TIA患者，血压应控制在＜130/80mmHg;",
                            check:0,
                            isAnswer:1
                        },
                        ]},
                    {
                        question:"对于既往经单药（ACEI、ARB、CCB、利尿剂）治疗后血压不达标的患者，您最优先考虑的调整治疗方案是？",
                        type:"1",
                        resolves:[{
                            resolve:"A. 同品类降压药增加剂量（举例：ACEI类药物单药增加剂量）",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 不同品类降压药转换（举例：ARB类药物换ACEI类药物）",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 换药，直接更换成SPC（举例：ACEI+CCB类SPC）",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"D. 自由联合其他药物（举例：ACEI类、CCB类）",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"E. 其他情况（请说明）",
                            check:0,
                            isAnswer:0
                        }

                        ]},
                    {
                        question:"关于高血压的治疗，对于哪些患者您考虑起始治疗使用单片复方制剂（SPC）？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 绝大多数高血压患者都可以选择SPC起始治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 有大于等于160/100mmHg（或高于目标值20mmHg）的患者，应该考虑SPC起始治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"C. 心血管风险为高危/很高危的患者，应该考虑SPC起始治疗",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 不认同起始SPC的理念",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 其他情况（请说明）",
                            check:0,
                            isAnswer:1
                        }
                        ]
                    },
                    {
                        question:"对于A+C SPC，您认为在哪些方面较A+D SPC 有所优势？",
                        type:"2",
                        resolves:[{
                            resolve:"A. A+C SPC较A+D SPC：适用人群广",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. A+C SPC较A+D SPC：血压达标率高",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. A+C SPC较A+D SPC：循证证据充分",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. A+C SPC较A+D SPC：获更多指南的推荐",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"对于A+C SPC的选择，您优先考虑的三个因素是什么？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 强效降压（降压幅度大）",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 平稳降压（波动小）",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 长效降压（半衰期长）",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 快速起效",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 早期达标",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"F. 有心血管保护作用",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"G.服药方便/患者依从性高",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"对比其他A+C的SPC（缬沙坦/氨氯地平片等），您认为10mg精氨酸培哚普利+5mg氨氯地平SPC在以下哪些方面更有优势？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 血压达标率高",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 降压幅度高",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 半衰期长",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 平稳降压，有效控制24h血压",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E. 心血管保护（降低全因死亡率和心血管事件）",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"您在使用10mg精氨酸培哚普利+5mg氨氯地平SPC过程中最大的顾虑是？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 担心发生低血压风险",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 担心出现咳嗽问题",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. 担心有水肿问题",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 单片复方制剂，不能掰片使用",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"E.其他情况（请说明）",
                            check:0,
                            isAnswer:1
                        }]
                    },
                    {
                        question:"以下哪些是10mg精氨酸培哚普利+5mg氨氯地平SPC 的产品信息？",
                        type:"2",
                        resolves:[{
                            resolve:"A. 更长半衰期，确保24小时长效平稳降压",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"B. 治疗12周，血压达标率可达93.5%",
                            check:0,
                            isAnswer:0
                        },{
                            resolve:"C. ASCOT研究证实更优心脑肾保护",
                            check:0,
                            isAnswer:1
                        },{
                            resolve:"D. 高血压患者的基础疗法",
                            check:0,
                            isAnswer:1
                        }]
                    },
                ],

            }
        },
        methods:{
            modelReason(index){
                switch (index) {
                    case 1:
                        return "reason1"
                    case 2:
                        return "reason2"
                    default:
                        return "reason3"
                }
            },
            reasonShow(resolve){
                let resolves = resolve.resolves
                for(let r of resolves){
                    if(r.resolve.indexOf("请说明")!=-1&&r.check==1){
                        return true
                    }
                }
                return false
            },
            toSubmit(){
                for(let i=1;i<=this.questions.length;i++){
                    let docAnswer = this.getAnswer(i);
                    console.log(docAnswer,"docAnswer")
                    if(docAnswer=="[]"){
                        this.$toast("请选择第"+i+"题答案")
                        return;
                    }

                    if(docAnswer ==null||docAnswer==""){
                        this.$toast("请选择第"+i+"题答案")
                        return;
                    }

                    let resolves = this.questions[i-1];
                    for(let item of resolves.resolves){
                        if(item.resolve.indexOf("请说明")!=-1&&item.check==1){
                            let value = document.getElementById("reason"+i).value
                            if(value==null||value==""){
                                this.$toast("请填写第"+i+"题理由")
                                return;
                            }

                        }
                    }
                }



                this.doSurvey(this.docId,this.phase,this.getAnswer(1), this.getAnswer(2),this.getAnswer(3),this.getAnswer(4),this.getAnswer(5),
                    this.getAnswer(6),this.getAnswer(7),this.getAnswer(8))
            },
            getAnswer(index){
                const question = this.questions[index-1]
                let resolves = question.resolves;
                let answer="";

                for(let resolve of resolves){
                    if(resolve.check==1){
                        answer+= "'"+ resolve.resolve+"',"
                    }
                    if(resolve.resolve.indexOf("请说明")!=-1&&resolve.check==1){
                        console.log("cy")
                        let value = document.getElementById("reason"+(index)).value
                        // answer+=value+","
                        answer+= "'"+ value+"',"
                    }
                }
                return "[" + answer+"]"
                // return answer.substring(0,answer.length-1)
            },
            resolveSelect(item,resolve){
                let type = item.type
                if(type==1){//单选题
                    for(let r of item.resolves){
                        r.check = 0
                    }
                    resolve.check=1
                }else{  //多选题
                    if(resolve.check==0){
                        resolve.check=1
                    }else{
                        resolve.check=0
                    }
                }
            },
            async doSurvey(docId,times,q1,q2,q3,q4,q5,q6,q7,q8,q9,q10){
                const res = await ksdDocSurvey({docId,times,q1,q2,q3,q4,q5,q6,q7,q8,q9,q10})
                if(res.data.success){
                    this.$router.replace("docStar")
                }
            }
        },
        mounted(){
            this.phase = this.$route.query.phase
            if(this.phase==2){
                this.questions = this.questions2
                this.times = "二"
            }else{
                this.questions = this.questions1
                this.times = "一"
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-flow: column;
        overflow: scroll;
        font-size: 16px;
    }
    .content{
        flex-grow: 1;
    }
    .head{
        width: 100%;
        position: relative;
    }
    .head .logo{
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 10px 0;
        .logo_1{
            width: 30px;
            height: 30px;
            margin-left: 20px;
        }
        .logo_2{
            width: 90px;
            height: 30px;
            margin-right: 20px;
        }
    }
    .kv{
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
        img{
            width: 275px;
            height: 157px;
        }
    }
    .content{
        width: 90%;
        margin: 0 auto;
        text-align: left;
        .hint{
            display: block;
            text-indent: 20px;
        }
        .title{
            margin: 20px 0px 10px 0px;
            color: #2c9a58;
            font-size: 20px;
            font-weight: bold;
        }
        .question-wrap .question{
            font-weight: bold;
            background: #d6ebe1;
            border-radius: 5px;
            padding: 5px 0;
            text-indent: 5px;
            font-size: 16px;
        }
        .question-wrap .resolves{
            padding: 8px 0;
            font-size: 15px;
        }
        .question-wrap .resolves .resolve{
            display: flex;
            flex-direction: row;
            margin: 8px 0;
            /*align-items: center;*/

            label{
                width: 100%;
                text-align: justify;
            }
        }
        .question-wrap .radio{
            display: block;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            margin: 5px 5px 0px 10px;
        }
        .question-wrap .radio-uncheck{
            border: 1px solid #000;
            background: transparent;
        }
        .question-wrap .radio-check{
            background: #2c9a58;
            border: 1px #2c9a58 solid;
        }
    }
    .content .submit{
        width: 100%;
        margin: 20px auto;
        background: #2c9a58;
        text-align: center;
        border-radius: 5px;
        color: #FFF;
        font-size: 16px;
        padding: 5px 0;
    }
    .reason{
        width: 100%;
    }
    input{
        width: 90%;
        display: block;
        margin: 10px auto;
        height: 22px;
        outline: none;
        border: #2c9a58 1px solid;
        text-indent: 10px;
        font-size: 16px;
    }
</style>